import { Component } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { Router } from '@angular/router';
import { LanguageModel } from 'src/app/core/services/api-services';
import { LanguageService } from 'src/app/core/services/language.service';
import { BaseComponent } from 'src/app/core/components/base.component';
import FormHelper from 'src/app/core/helpers/form.helper';
import { OnInit } from '@angular/core';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss']
})
export class LanguageSelectorComponent extends BaseComponent implements OnInit {
  languages: LanguageModel[] = [];

  public currentLanguage$: ReplaySubject<LanguageModel | undefined> = new ReplaySubject<LanguageModel | undefined>(1);

  constructor(
    private readonly languageService: LanguageService,
    private readonly router: Router
  ) {
    super();
  }

  ngOnInit(): void {
    this.languageService.getLanguages()
      .unsubscribeOnDestroy(this)
      .subscribe((langs) => {
        this.languages = langs ?? [];

        this.languageService.currentLanguage$
          .unsubscribeOnDestroy(this)
          .subscribe(language => {
            const selectedLanguage = this.languages.find(l => l.code == language.code);

            this.currentLanguage$.next(selectedLanguage!);
          });
      });
  }

  protected changeLanguage(code: string): void {
    this.languageService.setLanguageByCode(code)
      .unsubscribeOnDestroy(this)
      .subscribe(() => {
        FormHelper.reloadSelf(this.router);
      });
  }
}
